<template>
  <div class="box box-primary">
    <div class="box-header with-border">
      <h3 class="box-title">
        {{ $t('string.upload_loan_and_collection_officer') }}
      </h3>
      <div class="box-tools">
        <button
          class="btn btn-sm btn-primary margin-r-5"
          @click="updateAllBorrowsFromBackendToLoandisk"
        >
          {{ $t('button.update_all_borrows_from_backend_to_loandisk') }}
        </button>
        <button
          class="btn btn-sm btn-default"
          @click="$router.back()"
        >
          {{ $t('button.back') }}
        </button>
      </div>
    </div>
    <div class="box-body">
      <button
        :disabled="isDownloading"
        class="btn btn-info margin-r-5"
        @click="download"
      >
        <template v-if="isDownloading">
          <i class="fa fa-circle-o-notch fa-spin" /> {{ $t('string.processing') }}
        </template>
        <template v-else>
          <i class="fa fa-download" /> {{ $t('button.download') }}
        </template>
      </button>
      <button
        :disabled="isUploading"
        class="btn btn-primary"
        @click="() => {$refs.file.value = ''; $refs.file.click()}"
      >
        <input
          ref="file"
          type="file"
          @change="upload"
          name="file"
          id="file"
          style="display: none;"
        >
        <template v-if="isUploading">
          <i class="fa fa-circle-o-notch fa-spin" /> {{ $t('string.processing') }}
        </template>
        <template v-else>
          <i class="fa fa-upload" /> {{ $t('button.upload') }}
        </template>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadLoanAndCollectionOfficer',
  metaInfo () {
    return {
      title: this.$t('string.upload_loan_and_collection_officer'),
      titleTemplate: '%s | ' + process.env.VUE_APP_NAME
    }
  },
  data () {
    return {
      isDownloading: false,
      isUploading: false
    }
  },
  methods: {
    upload () {
      if (this.$refs.file.files && this.$refs.file.files[0]) {
        const params = new FormData()
        params.set('file', this.$refs.file.files[0])

        this.isUploading = true
        this.$isLoading(true)

        this.$axios.post(process.env.VUE_APP_API + '/api/v1/client/loan-and-collection-officer/upload', params)
          .then(() => {
            this.showToastr()
          })
          .catch((error) => {
            this.onResponseError(error)
          })
          .finally(() => {
            this.isUploading = false
            this.$isLoading(false)
          })
      }
    },
    download () {
      this.isDownloading = true
      const filename = 'loan-and-collection-officer'
      const url = process.env.VUE_APP_API + '/api/v1/client/loan-and-collection-officer/download'
      const params = {}

      this.$axios({ method: 'POST', url, params, responseType: 'blob' })
        .then((response) => {
          if (response.data) {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
            })
            const aEle = document.createElement('a')
            const href = window.URL.createObjectURL(blob)
            aEle.href = href
            aEle.download = filename
            document.body.appendChild(aEle)
            aEle.click()
            document.body.removeChild(aEle)
            window.URL.revokeObjectURL(href)
          }
        })
        .catch((error) => {
          this.onResponseError(error)
        })
        .finally(() => {
          this.isDownloading = false
        })
    },
    updateAllBorrowsFromBackendToLoandisk () {
      this.$swal({
        title: this.$t('string.are_you_sure'),
        text: this.$t('string.it_will_update_all_borrows_form_the_backend_to_loandisk'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('button.yes_i_am_sure'),
        cancelButtonText: this.$t('button.cancel')
      }).then((result) => {
        if (result.value) {
          this.$axios.post(process.env.VUE_APP_API + '/api/v1/client/loan-and-collection-officer/update-all-borrows-from-backend-to-loandisk')
            .then(() => {
              this.$toastr('success', this.$t('string.it_takes_along_time_to_do_this'), this.$t('string.success'))
            })
            .catch((error) => {
              this.onResponseError(error)
            })
            .finally(() => {
              this.isUploading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
